import { api } from './api';
import type { DashboardStatsResponse } from '../types/dashboard';

/**
 * Get dashboard statistics
 */
export const getDashboardStats = async (): Promise<DashboardStatsResponse> => {
  const response = await api.get<DashboardStatsResponse>('/dashboard/stats');
  return response.data;
};

export default {
  getDashboardStats,
};
